import { useContext } from 'react';
import { AuthContext } from '../providers/AuthProvider';

/**
 * useAuth hook
 * @returns {AuthProviderState}
 */
export const useAuth = () => useContext(AuthContext);
